import React from 'react';
import { Box } from '@chakra-ui/react';
import SearchContainer from './SearchContainer';
import SearchBar from './SearchBar';
import MessagesList from './MessagesList';

const Inbox = () => {
  const buttonNames = ['All', 'Unread', 'Recent', 'Stared'];

  return (
    <>
      {/* <SearchContainer buttonNames={buttonNames} /> */}
      <SearchBar />
      <Box
        width="100%"
        height="74vh"
        overflowY="auto"
        borderRadius="md"
        css={{
          '&::-webkit-scrollbar': {
            width: '4px',
            height: '50vh',
          },
          '&::-webkit-scrollbar-track': {
            background: '#ffffff',
            borderRadius: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#E7B9B1',
            borderRadius: '8px',
          },
        }}
      >
        <MessagesList />
      </Box>
    </>
  );
};

export default Inbox;
